import router, { asyncRoutes } from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import { Message } from 'element-ui'
import { filterAsyncRoutes as filterRoutes } from '@/utils/permissionFilter'
import { trackAdminPageView } from '@/api'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login']
let lastPageKey = ''
let lastPageAt = 0

function reportAdminPageView(to) {
  try {
    if (!getToken()) return
    if (!to || !to.path || to.path === '/login') return
    const key = to.fullPath || to.path
    const now = Date.now()
    if (key === lastPageKey && now - lastPageAt < 2000) return
    lastPageKey = key
    lastPageAt = now
    const title = (to.meta && to.meta.title) || ''
    trackAdminPageView({ page: to.path, title }).catch(() => {})
  } catch (e) { /* ignore */ }
}

/** 挂在 router 上，HMR 多次执行本文件时仍共用同一状态，避免重复 beforeEach 死循环 */
function isRoutesReady() {
  return !!router.__adminRoutesReady
}
function setRoutesReady(val) {
  router.__adminRoutesReady = !!val
}

export function resetPermissionGuard() {
  setRoutesReady(false)
  router.__ensureRoutesPromise = null
}

async function ensureDynamicRoutes() {
  if (isRoutesReady()) return
  if (router.__ensureRoutesPromise) return router.__ensureRoutesPromise

  router.__ensureRoutesPromise = (async () => {
    if (!store.getters.infoLoaded) {
      await store.dispatch('user/getInfo')
    }
    if (isRoutesReady()) return

    const accessRoutes = filterRoutes(asyncRoutes, store.getters.permissions, {
      roles: store.getters.roles || [],
      isSuper: !!store.getters.isSuper,
      userInfo: store.getters.userInfo || {}
    })

    router.addRoutes(accessRoutes)
    // mutation 内会剥掉 component，只留侧栏 meta
    store.commit('permission/SET_ROUTES', accessRoutes)
    setRoutesReady(true)
  })().catch(err => {
    router.__ensureRoutesPromise = null
    throw err
  })

  return router.__ensureRoutesPromise
}

// 只注册一次：HMR 热更新 permission.js 时不会叠加守卫
if (!router.__permissionGuardInstalled) {
  router.__permissionGuardInstalled = true

  router.beforeEach(async (to, from, next) => {
    NProgress.start()
    const hasToken = getToken()

    if (!hasToken) {
      setRoutesReady(false)
      if (whiteList.indexOf(to.path) !== -1) {
        next()
      } else {
        next(`/login?redirect=${to.path}`)
      }
      NProgress.done()
      return
    }

    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
      return
    }

    if (isRoutesReady() && store.getters.infoLoaded) {
      next()
      return
    }

    try {
      await ensureDynamicRoutes()
      // 勿展开整个 Route（含 matched），只带必要字段，且只 replace 一次
      next({ path: to.path, query: to.query, hash: to.hash, replace: true })
    } catch (error) {
      setRoutesReady(false)
      await store.dispatch('user/resetToken')
      Message.error((error && error.message) || '获取用户信息失败')
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  })

  router.afterEach((to) => {
    NProgress.done()
    reportAdminPageView(to)
  })
}
